const Decimal = ({value: {value, dp}}) => {
   return value.toFixed(dp);
};

export default Decimal;
